export default __webpack_public_path__ + "static/media/yoga.76760efc.svg";